export default __webpack_public_path__ + "static/agnew-bb3ce73fc9c46437f092ef73a5831f2c.jpg";